var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Interfaces.LayerGroupCanvas = {
    has_canvas: true,
    init_canvas_events: function () {
        this.addEvent('add_layer', this.on_add_layer_canvas.bind(this));
    },
    get_canvas_info: function () {

    },
    get_pixel_from_coordinate: function () {

    },
    on_add_layer_canvas: function (layer_obj) {
        layer_obj.set_canvas_draw_methods(this.get_canvas_info, this.get_pixel_from_coordinate);
        layer_obj.addEvent('render', this.on_render_canvas.bind(this));
        layer_obj.addEvent(OCS.Viewer.Config.events.LAYER_DRAW_FINISH, this.on_draw_finish.bind(this));
    },
    on_draw_finish: function (src, layer) {
        this.on_render_canvas(src);
    },
    on_render_canvas: function (src) {
        this.fireEvent('render', src);
    }
};


